<script lang="ts">
    import * as Popover from "$lib/components/ui/popover";
    import Button from "@/lib/components/ui/button/button.svelte";
    import AvailabilityEditor from "./AvailabilityEditor.svelte";
    import type { Availability } from "@/Common/constants";

    // The availability editor in a popover: see AvailabilityEditor for what the props are.
    export let defaultAvailability: Availability
    export let id: string
    export let dowLabel: string
    export let medians: { duration: number, time: string, high?: boolean } | null = null
    export let scopeLabel: string | null = null
    export let scope: "day" | "weekday" = "day"
    export let resetDot: "red" | "yellow" | null = null
    export let showSave = false
    export let saveDisabled = false
    // Which side of its trigger it opens on. It flips to the other side when there is more room there, and beside its trigger
    // (right or left) it can shift up or down to stay on screen.
    export let side: "top" | "right" | "bottom" | "left" = "bottom"
</script>

<!-- Kept inside the screen (collisionPadding): no taller than the room on its side (fitViewport), scrolling when that is less than
     its height, as on a short screen or in a dialog, which the page can't scroll to the rest of -->
<Popover.Content class="box-border w-[22rem] max-w-[calc(100vw-2rem)] overflow-y-auto" {side} align="start" collisionPadding={8} fitViewport>
    <AvailabilityEditor bind:defaultAvailability bind:scope {id} {dowLabel} {medians} {scopeLabel} {resetDot} {showSave} {saveDisabled}
        on:save on:reset on:scope>
        <svelte:fragment slot="save" let:save let:disabled>
            <Popover.Close asChild let:builder>
                <Button builders={[builder]} size="sm" {disabled} on:click={save}>Save</Button>
            </Popover.Close>
        </svelte:fragment>
    </AvailabilityEditor>
</Popover.Content>
